import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';

/**
 * This is to track the deal details mutation keys in react query cache.
 */
export const DEAL_DETAILS_QUERY = 'deal-details-query-key';

/**
 * This hook fetches the deal details using appraisal code as parameter.
 */
export const useDealDetailsQuery = (appraisalCode: string) => {
  const { data, isPending, isFetching, isError, error, refetch } =
    useQueryWithUserId({
      queryKey: [DEAL_DETAILS_QUERY, appraisalCode],
      enabled: !!appraisalCode,
      networkMode: 'always',
      retry: 3,
      queryFn: () => CUSTOMER_SERVICE_API.fetchDealDetails(appraisalCode),
    });

  return {
    data,
    error,
    isPending,
    isFetching,
    isError,
    refetch,
  };
};
